import { openDB } from 'idb';
import { IndexedDb } from 'config/constants';

class IndexDbStore {
  private static instance: IndexDbStore;

  indexedDBPromise: any;

  constructor() {
    if (window.indexedDB) {
      this.indexedDBPromise = openDB(IndexedDb.storeName, 1, {
        upgrade(db) {
          try {
            if (db) {
              Object.keys(IndexedDb.collections).forEach((collection) => {
                db.createObjectStore(IndexedDb.collections[collection]);
              });
            }
          } catch (err) {
            // continue regardless of error
          }
        },
      }).catch((_error) => {
        this.indexedDBPromise = null;
      });
    }
  }

  static getInstance(): IndexDbStore {
    if (!IndexDbStore.instance) {
      IndexDbStore.instance = new IndexDbStore();
    }
    return IndexDbStore.instance;
  }

  setToIndexedDB = async (key: string, val: string, collectionName: string) => {
    try {
      (await this.indexedDBPromise).put(collectionName, val, key);
    } catch (err) {
      // continue regardless of error
    }
  };

  getFromIndexedDB = async (key: string, collectionName: string): Promise<any> => {
    try {
      return (await this.indexedDBPromise).get(collectionName, key);
    } catch (err) {
      return null;
      // continue regardless of error
    }
  };

  getAllDataFromCollection = async (collectionName: string) => {
    /*
      We are taking the whole key value pairs from the db collection
      and make a whole object with the collection name and return
    */

    try {
      const data: Array<string> = await (await this.indexedDBPromise).getAll(collectionName);
      const key: Array<string> = await (await this.indexedDBPromise).getAllKeys(collectionName);

      const wholeData = key.map((eachKey: string, index: number) => ({
        key: eachKey,
        value: data[index],
      }));

      return { datacollectionName: collectionName, data: wholeData };
    } catch (err) {
      return null;
      // continue regardless of error
    }
  };

  clearDataStore = async (collectionName: string) => {
    try {
      return (await this.indexedDBPromise).clear(collectionName);
    } catch (err) {
      return null;
    }
  };
}
export default IndexDbStore;
export { IndexDbStore };
